export const getParamName = (paramName: string, tableId?: string): string => {
  return `${paramName}${tableId ? `_${tableId}` : ''}`;
};
